// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { setViewSize } from 'services/actions/viewActions';

function withViewSize<OwnProps>(
  WrappedComponent: React.AbstractComponent<OwnProps>
): React.AbstractComponent<OwnProps> {
  type DispatchProps = {|
    setViewSize: typeof setViewSize,
  |};

  type Props = {| ...DispatchProps, ...OwnProps |};
  class ViewSizeHOC extends React.Component<Props> {
    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => this.props.setViewSize(window.innerWidth);

    render() {
      const { setViewSize, ...restOfProps } = this.props;
      return <WrappedComponent {...restOfProps} />;
    }
  }

  return connect(null, { setViewSize })(ViewSizeHOC);
}

export default withViewSize;
